export default __webpack_public_path__ + "static/media/synne.e96cf641.png";